module.exports = require('./dist/index').default;